import {GET_FAVORITES} from "@/store/storeconstants";

export default {
    [GET_FAVORITES](state) {
        return state.favorites;
    },

}